// extracted by mini-css-extract-plugin
export default {"LegalLine":"LegalLine_LegalLine__UgCz7","white":"LegalLine_white__2xxLd"};